import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import {
  dispatchFetchNewsletter,
  dispatchUpdateNewsletter
} from 'reduxModules/newsletter/dispatchers'
import { toastError } from '../../../../global/notifications'
import './styles.css'

export const NEWSLETTER_SETTING_LABEL =
  'Send me the free weekly newsletter and occasional offers. Unsubscribe anytime.'

const NOTES = {
  pending:
    'Check your inbox: we sent you an email to confirm. You’ll get the newsletter once you click the link in it.',
  subscribed: 'You’re subscribed to the newsletter.',
  unsubscribed: 'You won’t get the newsletter any more.'
}

const failure = {
  error: {
    id: 'newsletterSettingError',
    message:
      "Oops! We couldn't update your newsletter preference. Please try again."
  }
}

/**
 * SPEC-099 FR-9: opt in or out of the newsletter at any time. Reads the
 * current state on mount (older accounts and anyone who consented read as
 * on, unless they unsubscribed through a Mailchimp link). Turning it back on
 * after unsubscribing that way sends a Mailchimp confirmation email, which
 * the note says.
 */
function NewsletterSetting() {
  const dispatch = useDispatch()
  const [subscribed, setSubscribed] = useState(null)
  const [saving, setSaving] = useState(false)
  const [note, setNote] = useState(null)

  useEffect(() => {
    let active = true
    dispatchFetchNewsletter(dispatch).then((state) => {
      if (active && state) setSubscribed(state.subscribed)
    })
    return () => {
      active = false
    }
  }, [])

  // The state couldn't be read: say nothing rather than show a wrong switch
  if (subscribed === null) return null

  const onChange = (event) => {
    const wanted = event.target.checked
    setSaving(true)
    setNote(null)
    dispatchUpdateNewsletter(dispatch, wanted)
      .then((result) => {
        if (result.error) {
          toastError({
            error: {
              ...failure.error,
              ...(typeof result.error === 'string' && { message: result.error })
            }
          })
          return
        }
        setSubscribed(result.subscribed)
        setNote(NOTES[result.status] || null)
      })
      .finally(() => setSaving(false))
  }

  return (
    <div className="NewsletterSetting">
      <h3 className="account-section__title">Newsletter</h3>
      <div className="NewsletterSetting__row">
        <input
          type="checkbox"
          id="newsletter-setting"
          checked={subscribed}
          disabled={saving}
          onChange={onChange}
        />
        <label htmlFor="newsletter-setting">{NEWSLETTER_SETTING_LABEL}</label>
      </div>
      <p className="NewsletterSetting__note" role="status">
        {note}
      </p>
    </div>
  )
}

export default NewsletterSetting
